import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-breadcrumbs', 'title', 'Leivapuru navigatsioon');
